module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('EditableSelectList', {
    attrs: {
      "selectedObjectType": _vm.mode,
      "objectTypes": _vm.objectTypesDisplay,
      "rows": _vm.rows,
      "columns": _vm.columns,
      "selectedRowId": _vm.selectedObject && _vm.selectedObject.id,
      "selectRow": function (row) {
        _vm.selectedObject = row;
      },
      "addRow": _vm.addRowPermitted && _vm.createObject,
      "editRow": _vm.modifyObject,
      "destroyRow": _vm.destroyObject,
      "duplicateRow": _vm.duplicateRow,
      "searchAvailable": _vm.searchAvailable,
      "compact": _vm.compact
    },
    on: {
      "toggleCompact": function (c) { return _vm.$emit('toggleCompact', c); },
      "selectObjectType": _vm.changeMode
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a0779666!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Library.vue
// module id = 689
// module chunks = 2